<div class="container">
<lib-empty-state [showButton]="showButton" [heading]="'You don’t have access to this page'" [subHeading]="'Access this page upon being granted permission.'"></lib-empty-state>
</div>